import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
@observer
export default class extends Component {
  render() {
    const { children } = this.props
    return <div className={style.container}>{children}</div>
  }
}
